export const antiNameHandler = (name: string) => {

    switch (name) {
        case 'clamav':
            return 'ClamAV'
        case 'comodo':
            return 'Comodo'
        case 'drweb':
            return 'DrWeb'
        case 'eset':
            return 'ESET Nod32'
        case 'fprot':
            return 'FPROT'
        case 'fsecure':
            return 'F-Secure'
        case 'mcafee':
            return 'McAfee'
        case 'nsrl':
            return 'NSRL'
        case 'symantec':
            return 'Symantec'
        case 'kaspersky':
            return 'Kaspersky'
        case 'yara':
            return 'yara'
        case 'escan':
            return 'eScan'
        case 'emsisoft':
            return 'Emsisoft'
        case 'sanitizer':
            return 'Sanitizer'
        case 'vulnerabilitydetection':
            return 'Vulnerability Detection'
        case 'quickheal':
            return 'Quick Heal'
        case 'windowsdefender':
            return 'Windows Defender'
        case 'padvish':
            return 'Padvish'
        case 'bitdefender':
            return 'Bitdefender'
        case 'gdata':
            return 'G Data'
		case 'avast':
            return 'Avast'
		case 'adaware':
            return 'Adaware'
		case 'avira':
            return 'Avira'
        case 'trendmicro':
            return 'Trend Micro'
        default:
            return "Unknown"
    }

}
